// import * as R from 'ramda';

import * as R from 'ramda';
import changeLogTypes from '../changeLog/change-log-types.json';

export default function SyncRecommendedChangesDialogController(
  $rootScope,
  $scope,
  alerts,
  confirmDialog,
  loaderService,
  ssDialogService,
  pmDataService,
  pmSharedModelService,
  approveChangeConfirmDialog,
  denyChangeConfirmDialog,
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;

  vm.handleClearFiltersClick = _handleClearFiltersClick;
  vm.handleToggleFiltersClick = _handleToggleFiltersClick;

  vm.handleApproveChangeClick = _handleApproveChangeClick;
  vm.handleDenyChangeClick = _handleDenyChangeClick;
  vm.handleApproveAllChangesClick = _handleApproveAllChangesClick;
  vm.handleDenyAllChangesClick = _handleDenyAllChangesClick;
  vm.showingChangesMessage = '';
  vm.showingFilteredChanges = false;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initWatchers();
    _initEventListeners();
    _initStartingFilters();
    _clearFilters();
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleClearFiltersClick() {
    _clearFilters();
    _filterItems();
  }

  function _handleToggleFiltersClick() {
    vm.showFilters = !vm.showFilters;
  }

  function _handleApproveChangeClick($event, change) {
    let changeType;
    let changeEffects;
    if (change.changeEntity === 'Section Title') {
      changeType = `Section "${change.documentSectionCode}" Title`;
      changeEffects = "Section's title";
    } else if (change.changeEntity === 'Section Body') {
      changeType = `Section "${change.documentSectionCode}" Body`;
      changeEffects = "Section's body";
    } else if (change.changeEntity === 'EndNote') {
      changeType = `Endnote "${change.tag}"`;
      changeEffects = "Endnote's text";
    } else {
      changeType = 'Batch Update';
      changeEffects = 'Batch Update';
    }

    ssDialogService.dialogs.pm.confirmApproveChangeDialog = ssDialogService.alert(
      approveChangeConfirmDialog.getOptions($event, {
        changeType,
        changeEffects,
        change,
        changedIds: vm.changedIds,
        changesAreRecommended: vm.changesAreRecommended,
        newChanges: vm.newChanges,
        updateCallback: _updateCallback,
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.pm.confirmApproveChangeDialog);
  }

  function _handleDenyChangeClick($event, change) {
    let changeType;
    let changeEffects;
    if (change.changeEntity === 'Section Title') {
      changeType = `Section ${change.documentSectionCode} Title`;
      changeEffects = "Sectifion's Title";
    } else if (change.changeEntity === 'Section Body') {
      changeType = `Section ${change.documentSectionCode} Body`;
      changeEffects = "Section's Body (but not the Additional Details)";
    } else if (change.changeEntity === 'EndNote') {
      changeType = `Endnote ${change.tag}`;
      changeEffects = "Endnote's text";
    } else {
      changeType = 'Batch Update';
      changeEffects = 'Batch Update';
    }

    const _change = angular.copy(change);
    ssDialogService.dialogs.pm.confirmDenyChangeDialog = ssDialogService.alert(
      denyChangeConfirmDialog.getOptions($event, {
        changeType,
        changeEffects,
        change: _change,
        changedIds: vm.changedIds,
        changesAreRecommended: vm.changesAreRecommended,
        newChanges: vm.newChanges,
        updateCallback: _updateCallback,
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.pm.confirmDenyChangeDialog);
  }

  function _handleApproveAllChangesClick($event) {
    ssDialogService.dialogs.pm.confirmApproveAllChangesDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Approve All Changes?',
        message: 'Are you sure you want to approve all changes based on the recommendations?',
        handleYesClick: _handleConfirmApproveAllChanges,
        handleNoClick: _closeApproveAllChangesDialog,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.confirmApproveAllChangesDialog);
  }

  function _handleDenyAllChangesClick($event) {
    ssDialogService.dialogs.pm.confirmDenyAllChangesDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Deny All Changes?',
        message: `Are you sure you want to deny all recommendations? This will require
        you to manage the content in the affected sections.`,
        handleYesClick: _handleConfirmDenyAllChanges,
        handleNoClick: _closeDenyAllChangesDialog,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.confirmDenyAllChangesDialog);
  }

  // //////// UTILITY METHODS //////////
  function _updateCallback(change) {
    if (change.changeEntity === 'Batch') {
      if (change.items && change.items.length > 0) {
        R.forEach(item => {
          _removeChangeFromList(item);
        }, change.items);
      }
    } else {
      _removeChangeFromList(change);
    }
    _filterItems();
  }

  function _initWatchers() {
    $scope.$watch(
      () => vm.filters,
      () => {
        _filterItems();
      },
      true,
    );
  }

  function _initEventListeners() {}

  function _initStartingFilters() {
    vm.clearedFilters = {
      keywordText: '',
      includeSectionTitles: true,
      includeSectionBodies: true,
      includeVariables: true,
      includeEndnotes: true,
      includeAcceptedRecommendations: true,
      includeRejectedRecommendations: true,
      includeMaterialChanges: true,
      includeImmaterialChanges: true,
      includeCreatedChangeTypes: true,
      includeUpdatedChangeTypes: true,
      includeDeletedChangeTypes: true,
      includeMovedChangeTypes: true,
      includeAltTextTitleUpdatedChangeTypes: true,
      includeAltTextBodyUpdatedChangeTypes: true,
      includeSortOrderChangeTypes: true,
    };
  }

  function _clearFilters() {
    vm.filters = R.clone(vm.clearedFilters);
  }

  function _filterItems() {
    vm.filteredRecommendedChangeItems = R.filter(recommendedChangeItem => {
      const keywordTextMatches = _checkKeywordTextMatches(recommendedChangeItem, vm.filters.keywordText);
      const typeIsIncluded = _checkTypeIsIncluded(recommendedChangeItem, vm.filters, changeLogTypes);

      if (recommendedChangeItem.changeLogTypeId === 18) {
        recommendedChangeItem.include = 1;
      }

      const materialTypeIsIncluded = _checkMaterialTypeIsIncluded(recommendedChangeItem, vm.filters);
      const changeTypeIsIncluded = _checkChangeTypeIsIncluded(recommendedChangeItem, vm.filters);

      return keywordTextMatches && typeIsIncluded && materialTypeIsIncluded && changeTypeIsIncluded;
    }, vm.newChanges);

    _transformIntoBatchItems();
  }

  function _checkKeywordTextMatches(recommendedChangeItem, keywordText) {
    if (!keywordText) {
      recommendedChangeItem.isExpanded = false;
      return true;
    }

    if (
      (recommendedChangeItem.valueCurrent &&
        _checkTextSnippetMatches(recommendedChangeItem.valueCurrent, keywordText)) ||
      (recommendedChangeItem.valueTo && _checkTextSnippetMatches(recommendedChangeItem.valueTo, keywordText))
    ) {
      recommendedChangeItem.isExpanded = true;
      return true;
    }

    recommendedChangeItem.isExpanded = false;
    return false;
  }

  function _checkTextSnippetMatches(textToCheck, textToMatch) {
    return textToCheck.toLowerCase().indexOf(textToMatch.toLowerCase()) > -1;
  }

  function _checkTypeIsIncluded(recommendedChangeItem, filters, changeLogTypeConstants) {
    return (
      ((recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.SECTION_TITLE.changeLogTypeId ||
        recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.MASTER_SECTION_TITLE.changeLogTypeId ||
        recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.AltText_Title_Updated.changeLogTypeId) &&
        filters.includeSectionTitles) ||
      ((recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.SECTION_BODY.changeLogTypeId ||
        recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.MASTER_SECTION_BODY.changeLogTypeId ||
        recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.AltText_Body_Updated.changeLogTypeId) &&
        filters.includeSectionBodies) ||
      (recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.VARIABLE_VALUE.changeLogTypeId &&
        filters.includeVariables) ||
      ((recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.ENDNOTE_TEXT.changeLogTypeId ||
        recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.MASTER_ENDNOTE_TEXT.changeLogTypeId ||
        recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.MASTER_ENDNOTE_CREATED.changeLogTypeId) &&
        filters.includeEndnotes) ||
      (recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.Section_Created.changeLogTypeId &&
        (filters.includeSectionBodies || filters.includeSectionTitles)) ||
      ((recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.Master_Section_Created.changeLogTypeId ||
        recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.Master_Section_Updated.changeLogTypeId ||
        recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.Master_Section_Deleted.changeLogTypeId) &&
        // eslint-disable-next-line max-len
        (filters.includeSectionBodies || filters.includeSectionTitles)) ||
      (recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.Master_Section_Sort_Order.changeLogTypeId &&
        // eslint-disable-next-line max-len
        filters.includeSortOrderChangeTypes) ||
      (recommendedChangeItem.changeLogTypeId === changeLogTypeConstants.Master_Section_Moved.changeLogTypeId &&
        // eslint-disable-next-line max-len
        filters.includeMovedChangeTypes)
    );
  }

  function _checkMaterialTypeIsIncluded(recommendedChangeItem, filters) {
    return (
      (recommendedChangeItem.isMaterialChange && filters.includeMaterialChanges) ||
      (!recommendedChangeItem.isMaterialChange && filters.includeImmaterialChanges)
    );
  }

  function _checkChangeTypeIsIncluded(recommendedChangeItem, filters) {
    return (
      (recommendedChangeItem.changeType === 'Created' && filters.includeCreatedChangeTypes) ||
      (recommendedChangeItem.changeType === 'Updated' && filters.includeUpdatedChangeTypes) ||
      (recommendedChangeItem.changeType === 'Deleted' && filters.includeDeletedChangeTypes)
    );
  }

  function _removeChangeFromList(change) {
    // Remove from list for display
    vm.newChanges = vm.newChanges.filter(newChange => change.documentChangeLogId !== newChange.documentChangeLogId);
    // eslint-disable-next-line max-len
    if (
      change.changeEntity === 'Section Title' ||
      change.changeEntity === 'Section Body' ||
      change.changeEntity === 'Section Moved' ||
      change.changeEntity === 'Section Sort Order' ||
      change.changeEntity === 'EndNote'
    ) {
      // Is Section
      // Remove from list for approve/deny all
      switch (change.changeType) {
        case 'Added':
          vm.changedIds.addedMasterSectionIds = vm.changedIds.addedMasterSectionIds.filter(
            newChange => change.documentChangeLogId !== newChange.documentChangeLogId,
          );
          break;
        case 'Created':
          vm.changedIds.addedMasterSectionIds = vm.changedIds.addedMasterSectionIds.filter(
            newChange => change.documentChangeLogId !== newChange.documentChangeLogId,
          );
          break;
        case 'Updated':
          vm.changedIds.updatedSectionIds = vm.changedIds.updatedSectionIds.filter(
            newChange => change.documentChangeLogId !== newChange.documentChangeLogId,
          );
          break;
        case 'Deleted':
          vm.changedIds.deletedSectionIds = vm.changedIds.deletedSectionIds.filter(
            newChange => change.documentChangeLogId !== newChange.documentChangeLogId,
          );
          break;
        default:
          break;
      }
    } else {
      // Is FootNote
      // Remove from list for approve/deny all
      vm.changedIds = vm.changedIds.updatedEndNoteIds.filter(
        newChange => change.documentChangeLogId !== newChange.documentChangeLogId,
      );
    }
    if (vm.newChanges.length < 1) {
      _closeDialog();
    }
  }

  function _handleConfirmApproveAllChanges() {
    loaderService.showViewLoader = true;

    if (vm.changesAreRecommended) {
      const _changedItems = _getDisplayedChangedItems();
      pmDataService.acceptSyncedChanges(_changedItems).then(() => {
        loaderService.showViewLoader = false;
        alerts.success('All new changes have been successfully approved.');
        _closeApproveAllChangesDialog().then(() => {
          if (vm.showingFilteredChanges !== true) {
            _closeDialog();
          } else {
            _removeChangesFromList(vm.batchFilteredRecommendedChangeItems);
          }
        });
        $rootScope.$broadcast('refreshPMDocuments');
        $rootScope.$broadcast('refreshPmChangeLog');
      });
    } else {
      const policyDocumentSectionIds = [];
      vm.changedIds.updatedSectionIds.forEach(item => policyDocumentSectionIds.push(item.policyDocumentSectionId));
      if (vm.changedIds.updatedMasterSectionIds && vm.changedIds.updatedMasterSectionIds.length > 0) {
        // eslint-disable-next-line max-len
        vm.changedIds.updatedMasterSectionIds.forEach(item =>
          policyDocumentSectionIds.push(item.policyDocumentSectionId),
        );
      }
      pmDataService.syncSectionsToMaster(policyDocumentSectionIds).then(() => {
        loaderService.showViewLoader = false;
        alerts.success('All new changes have been successfully approved.');
        _closeApproveAllChangesDialog().then(_closeDialog);
        $rootScope.$broadcast('refreshPMDocuments');
        $rootScope.$broadcast('refreshPmChangeLog');
      });
    }
  }

  function _closeApproveAllChangesDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.confirmApproveAllChangesDialog);
  }

  function _handleConfirmDenyAllChanges() {
    loaderService.showViewLoader = true;
    const _changedItems = _getDisplayedChangedItems();
    pmDataService.denySyncedChanges(_changedItems).then(() => {
      loaderService.showViewLoader = false;
      alerts.success('All new changes have been successfully denied.');
      _closeDenyAllChangesDialog().then(() => {
        if (vm.showingFilteredChanges !== true) {
          _closeDialog();
        } else {
          _removeChangesFromList(vm.batchFilteredRecommendedChangeItems);
        }
      });
      $rootScope.$broadcast('refreshPMDocuments');
      $rootScope.$broadcast('refreshPmChangeLog');
    });
  }

  function _getDisplayedChangedItems() {
    const _changedItems = angular.copy(vm.changedIds);

    if (vm.batchFilteredRecommendedChangeItems !== null && vm.batchFilteredRecommendedChangeItems.length > 0) {
      if (_changedItems.addedMasterEndNoteIds !== null && _changedItems.addedMasterEndNoteIds.length > 0) {
        _changedItems.addedMasterEndNoteIds = R.filter(it => {
          if (vm.batchFilteredRecommendedChangeItems.includes(it)) {
            return it;
          }
          return false;
        }, vm.changedIds.addedMasterEndNoteIds);
      }
      if (_changedItems.addedMasterSectionIds !== null && _changedItems.addedMasterSectionIds.length > 0) {
        _changedItems.addedMasterSectionIds = R.filter(it => {
          if (vm.batchFilteredRecommendedChangeItems.includes(it)) {
            return it;
          }
          return false;
        }, vm.changedIds.addedMasterSectionIds);
      }
      if (_changedItems.createdMasterEndNoteIds !== null && _changedItems.createdMasterEndNoteIds.length > 0) {
        _changedItems.createdMasterEndNoteIds = R.filter(it => {
          if (vm.batchFilteredRecommendedChangeItems.includes(it)) {
            return it;
          }
          return false;
        }, vm.changedIds.createdMasterEndNoteIds);
      }
      if (_changedItems.deletedSectionIds !== null && _changedItems.deletedSectionIds.length > 0) {
        _changedItems.deletedSectionIds = R.filter(it => {
          if (vm.batchFilteredRecommendedChangeItems.includes(it)) {
            return it;
          }
          return false;
        }, vm.changedIds.deletedSectionIds);
      }
      if (_changedItems.updatedEndNoteIds !== null && _changedItems.updatedEndNoteIds.length > 0) {
        _changedItems.updatedEndNoteIds = R.filter(it => {
          if (vm.batchFilteredRecommendedChangeItems.includes(it)) {
            return it;
          }
          return false;
        }, vm.changedIds.updatedEndNoteIds);
      }
      if (_changedItems.updatedSectionIds !== null && _changedItems.updatedSectionIds.length > 0) {
        _changedItems.updatedSectionIds = R.filter(it => {
          if (vm.batchFilteredRecommendedChangeItems.includes(it)) {
            return it;
          }
          return false;
        }, vm.changedIds.updatedSectionIds);
      }
    }
    return _changedItems;
  }

  function _removeChangesFromList(changes) {
    if (changes && changes.length > 0) {
      R.forEach(item => {
        _removeChangeFromList(item);
      }, changes);
    }

    _filterItems();
  }

  function _closeDenyAllChangesDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.confirmDenyAllChangesDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.syncRecommendedChangesDialog);
  }

  function _transformIntoBatchItems() {
    vm.listWithBatches = [];
    const dict = {};
    let currentBatchItem = {};
    // let listOfBatchIds = [];
    if (vm.filteredRecommendedChangeItems && vm.filteredRecommendedChangeItems.length > 0) {
      // eslint-disable-next-line max-len
      let _filteredRecommendedChangeItems = vm.filteredRecommendedChangeItems;

      // let _filteredRecommendedChangeItems = R.filter(it => {
      //   if (it.changeEntity !== 'EndNote') {
      //     return it;
      //   }
      //   return false;
      // }, vm.filteredRecommendedChangeItems);

      // const _filteredSchemaChangeItems = R.filter(it => {
      //   if (it.changeLogBatch !== null && it.changeLogBatch.batchTypeId === 1) {
      //     return it;
      //   }
      //   return false;
      // }, _filteredRecommendedChangeItems);

      const _schemaAdds = _filterByChangeType(_filteredRecommendedChangeItems, 25);
      const _schemaDeletes = _filterByChangeType(_filteredRecommendedChangeItems, 26);
      const _schemaMoves = _filterByChangeType(_filteredRecommendedChangeItems, 27);

      if (_schemaAdds !== null && _schemaAdds.length > 0) {
        vm.showingChangesMessage = `Showing ${_schemaAdds.length} of ${_filteredRecommendedChangeItems.length} changes.  These are newly added master sections.`;
        _filteredRecommendedChangeItems = _schemaAdds;
        vm.showingFilteredChanges = true;
      } else if (_schemaDeletes !== null && _schemaDeletes.length > 0) {
        vm.showingChangesMessage = `Showing ${_schemaDeletes.length} of ${_filteredRecommendedChangeItems.length} changes.  These are newly deleted master sections.`;
        _filteredRecommendedChangeItems = _schemaDeletes;
        vm.showingFilteredChanges = true;
      } else if (_schemaMoves !== null && _schemaMoves.length > 0) {
        vm.showingChangesMessage = `Showing ${_schemaMoves.length} of ${_filteredRecommendedChangeItems.length} changes.  These are master sections that have moved.`;
        _filteredRecommendedChangeItems = _schemaMoves;
        vm.showingFilteredChanges = true;
      } else {
        vm.showingChangesMessage = `Showing ${_filteredRecommendedChangeItems.length} ${
          _filteredRecommendedChangeItems.length > 1 ? 'changes' : 'change'
        }`;
        vm.showingFilteredChanges = false;
      }

      _filteredRecommendedChangeItems = R.sortBy(R.prop('sortCodeString'), _filteredRecommendedChangeItems);

      vm.batchFilteredRecommendedChangeItems = _filteredRecommendedChangeItems;

      R.forEach(item => {
        // if (!item.batchId) {
        vm.listWithBatches.push(item);
        // } else if (!(item.batchId in dict)) {
        //   const matchedItems = R.filter(R.propEq('batchId', item.batchId), _filteredRecommendedChangeItems);
        //   dict[item.batchId] = matchedItems;
        //   currentBatchItem = {
        //     // eslint-disable-next-line max-len
        //     changeEntity: 'Batch',
        //     sortCodeString: item.sortCodeString,
        //     items: dict[item.batchId],
        //     documentSectionCode: item.documentSectionCode,
        //   };
        //   vm.listWithBatches.push(currentBatchItem);
        // }
      }, _filteredRecommendedChangeItems);

      var groupedBySection = R.groupBy(R.prop('documentSectionCode'), vm.listWithBatches);

      vm.listWithBatches = [];
      R.forEach(sections => {
        R.forEach(section => {
          vm.listWithBatches.push(section);
        }, R.sortBy(R.prop('changeLogTypeId'), sections));
      }, R.values(groupedBySection));
    }
  }
}

function _filterByChangeType(filteredRecommendedChangeItems, changeType) {
  const _filteredSchemaChangeItems = R.filter(it => {
    if (it.changeLogTypeId === changeType) {
      return it;
    }
    return false;
  }, filteredRecommendedChangeItems);

  return _filteredSchemaChangeItems;
}

SyncRecommendedChangesDialogController.$inject = [
  '$rootScope',
  '$scope',

  'alerts',
  'confirmDialog',
  'loaderService',
  'ssDialogService',
  'pmDataService',
  'pmSharedModelService',
  'approveChangeConfirmDialog',
  'denyChangeConfirmDialog',
];
